import { render, staticRenderFns } from "./FabricYarnTypeCreateEdit.vue?vue&type=template&id=02b4d480&scoped=true&"
import script from "./FabricYarnTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./FabricYarnTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./FabricYarnTypeCreateEdit.vue?vue&type=style&index=0&id=02b4d480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b4d480",
  null
  
)

export default component.exports